import useWindowSize from '@/common/hooks/useWindowSize'
import { Box } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { SidebarContext } from '../contexts/SidebarContext'
import Sidebar from './Sidebar'
import { TopBannersContext } from '../contexts/TopBannersContext'

interface Props {
  children: React.ReactNode
}

// The page itself, below the banners: same offset as the sidebar, which is
// fixed at the top too.
export default function LoggedContent({ children }: Props) {
  const windowSize = useWindowSize()
  const sidebarContext = useContext(SidebarContext)
  const topOffset = useContext(TopBannersContext)

  return (
    <>
      <Sidebar />
      <Box
        position="relative"
        h={0}
        minH={`${
          windowSize.height - (sidebarContext?.height || 0) - topOffset
        }px`}
        ml={sidebarContext?.width ? `${sidebarContext?.width}px` : 0}
        mt={`${(sidebarContext?.height || 0) + topOffset}px`}
        sx={{
          '@media print': {
            ml: 0,
            mt: 0,
          },
        }}
      >
        {children}
      </Box>
    </>
  )
}
